import { createStore } from "vuex";

import { actions } from '@/store/actions'
import { state } from '@/store/states'
import { getters } from '@/store/getters'
import { mutations } from '@/store/mutations'
///////////////////////////////////业务模块////////////////////////////////////////////
import { appSetting } from '@/store/modules/app/appsettings'
import { appUser } from '@/store/modules/app/appUser'

import { SysHosp } from '@/store/modules/sys/sysHosp'
import { SysHospUser } from '@/store/modules/sys/sysHospUser'
import { SysUser } from '@/store/modules/sys/sysUser'
import { SysRole } from '@/store/modules/sys/sysRole'

import { SysRoleUser } from '@/store/modules/sys/sysRoleUser'
import { SysRoleModules } from '@/store/modules/sys/sysRoleModules'

import { SysLog } from '@/store/modules/sys/sysLog'
import { MultiPageBar } from "@/store/modules/app/multiPageBar";

import { TgyBaseLink } from "@/store/modules/sys/link";

// 新增业务
import { HsmUnionpay } from "@/store/modules/pdm/unionpay"
import { PdmBanner } from "@/store/modules/pdm/banner"
import { PdmOrder } from "@/store/modules/pdm/order"
import { PdmRecvOrder } from "@/store/modules/pdm/recv_order"
import { PdmBodycheckFenlei } from "@/store/modules/pdm/bodycheckFenlei"
import { PdmBodycheckTags } from "@/store/modules/pdm/bodycheckTags"
import { PdmBodycheckPaiban } from "@/store/modules/pdm/bodycheckPaiban"
import { PdmBodycheckTaocan } from "@/store/modules/pdm/bodycheckTaocan"
import { PdmBodycheckTaocantype } from "@/store/modules/pdm/bodycheckTaocantype"
import { PdmBodycheckItem } from "@/store/modules/pdm/bodycheckItem"
import { PdmBodycheckPaibantiem } from "@/store/modules/pdm/bodycheckPaibantime"
import { PdmBodycheckDaoru } from "@/store/modules/pdm/bodycheckDaoru"
import { PdmBodycheckYuyue } from "@/store/modules/pdm/bodycheckYuyue"
import { PdmMaSchd } from "@/store/modules/pdm/ma/maSchd"
import { PdmMaSchdtime } from "@/store/modules/pdm/ma/maSchdtime"
import { PdmMaPack } from "@/store/modules/pdm/ma/maPack"
import { PdmMaPatientinfo } from "@/store/modules/pdm/ma/maPatientinfo"
import { PdmMaPath } from "@/store/modules/pdm/ma/maPath"
import { PdmMaPack2 } from "@/store/modules/pdm/ma/maPack2"
import { PdmMaType } from "@/store/modules/pdm/ma/maType"
import { PdmMaItem } from "@/store/modules/pdm/ma/maItem"
import { PdmMaPackItem } from "@/store/modules/pdm/ma/maPackItem"
import { PdmMaAppt } from "@/store/modules/pdm/ma/maAppt"
import { PdmKefu } from "@/store/modules/pdm/kefu"

export const store = createStore({
    modules:
    {
        appSetting,
        appUser,
        SysHosp,
        SysUser,
        SysRole,
        SysRoleUser,
        SysRoleModules,
        SysHospUser,
        SysLog,
        MultiPageBar,
        TgyBaseLink,
        HsmUnionpay,
        PdmBanner,
        PdmOrder,
        PdmRecvOrder,
        PdmBodycheckFenlei,
        PdmBodycheckTags,
        PdmBodycheckPaiban,
        PdmBodycheckTaocan,
        PdmBodycheckTaocantype,
        PdmBodycheckItem,
        PdmBodycheckPaibantiem,
        PdmBodycheckDaoru,
        PdmBodycheckYuyue,
        PdmMaSchd,
        PdmMaSchdtime,
        PdmMaPack,
        PdmMaPatientinfo,
        PdmMaPath,
        PdmMaPack2,
        PdmMaType,
        PdmMaPackItem,
        PdmMaItem,
        PdmMaAppt,
        PdmKefu
    },
    state,
    getters,
    actions,
    mutations
});
